"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const rates_1 = require("../../models/rates");
const transactionTypes = Object.values(rates_1.TransactionType);
exports.default = {
    id: joi_1.default.string().allow('').required(),
    orgKey: joi_1.default.string().required(),
    name: joi_1.default.string()
        .max(200)
        .min(1)
        .trim()
        .pattern(/^[\w\d][\s\S]*/)
        .required(),
    description: joi_1.default.string().allow('').required(),
    chargeLabel: joi_1.default.string().allow('').optional(),
    class: joi_1.default.string().allow('').optional(),
    transactionType: joi_1.default.string()
        .valid(...transactionTypes)
        .required(),
    category: joi_1.default.string().allow('').required(),
};
